// extracted by mini-css-extract-plugin
export default {"container":"Hero_container__-H7A7","text":"Hero_text__lYDnY","altColor":"Hero_altColor__LN2ru"};